enum Language {
  DANISH = 'da',
  ENGLISH = 'en',
}
export default Language
